import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Help14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_107)'>
      <path
        d='M7 11C7.55228 11 8 10.5523 8 10C8 9.44771 7.55228 9 7 9C6.44772 9 6 9.44771 6 10C6 10.5523 6.44772 11 7 11Z'
        fill='currentColor'
      />
      <path
        d='M6.25 5.5C6.25 5.08579 6.58579 4.75 7 4.75C7.41421 4.75 7.75 5.08579 7.75 5.5C7.75 5.73875 7.63929 5.95122 7.4634 6.08979C6.61704 6.75661 6.25 7.44977 6.25 8.5H7.75C7.75 7.8707 7.87443 7.67558 8.3917 7.26803C8.91306 6.85727 9.25 6.21777 9.25 5.5C9.25 4.25736 8.24264 3.25 7 3.25C5.75736 3.25 4.75 4.25736 4.75 5.5H6.25Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.99994 13.75H1.00004C0.391153 13.75 0.0344181 13.0286 0.404029 12.5447L1.57301 11.0144C0.742022 9.89257 0.25 8.50307 0.25 7C0.25 3.27208 3.27208 0.25 7 0.25C10.7279 0.25 13.75 3.27208 13.75 7C13.75 10.7279 10.7279 13.75 6.99994 13.75ZM7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 8.3451 2.25487 9.57049 3.08664 10.4998C3.32676 10.7681 3.34235 11.1692 3.12379 11.4553L2.51672 12.25H6.99977C9.89927 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_107'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Help14.displayName = 'Help14';
export default Help14;
